import * as moment from "moment";
import { IEntity } from "motw_core/Entity/IEntity";
import { ReadState } from "source/app/services/UI/State/ReadState";
import { ESharedFunction } from "motw_core/Enums/ESharedFunction";

export function HandleSystemDateOffset(data: object) {
    const lastModifiedTimeDaysOffset = ReadState<number>(
        ESharedFunction.SystemDateWarning_offset
    );

    const newLastModifiedTime = moment((data as IEntity).lastmodifiedtime)
        .add(lastModifiedTimeDaysOffset, "days")
        .toISOString();

    (data as IEntity).lastmodifiedtime = newLastModifiedTime;
}
